 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import LOVE_1 from '@/components/love_1'
 import CHAP139438 from '@/components/chap139438'
 import CHAP139422 from '@/components/chap139422'
 import CHAP139417 from '@/components/chap139417'
 import CHAP139416 from '@/components/chap139416'
 import CHAP139424 from '@/components/chap139424'
 import CHAP139423 from '@/components/chap139423'
 import CHAP139440 from '@/components/chap139440'
 import CHAP139441 from '@/components/chap139441'
 import CHAP139443 from '@/components/chap139443'
 import CHAP139435 from '@/components/chap139435'
 import CHAP139405 from '@/components/chap139405'
 import CHAP139436 from '@/components/chap139436'
 import CHAP139444 from '@/components/chap139444'
 import CHAP139425 from '@/components/chap139425'
 import CHAP139434 from '@/components/chap139434'
 import CHAP139421 from '@/components/chap139421'
 import CHAP139408 from '@/components/chap139408'
 import CHAP139406 from '@/components/chap139406'
 import CHAP139437 from '@/components/chap139437'
 import CHAP139410 from '@/components/chap139410'
 import CHAP139430 from '@/components/chap139430'
 import CHAP139431 from '@/components/chap139431'
 import CHAP139445 from '@/components/chap139445'
 import CHAP139428 from '@/components/chap139428'
 import CHAP139432 from '@/components/chap139432'
 import CHAP139413 from '@/components/chap139413'
 import CHAP139433 from '@/components/chap139433'
 import CHAP139418 from '@/components/chap139418'
 import CHAP139442 from '@/components/chap139442'
 import CHAP139429 from '@/components/chap139429'
 import CHAP139427 from '@/components/chap139427'
 import CHAP139420 from '@/components/chap139420'
 import CHAP139415 from '@/components/chap139415'
 import CHAP139439 from '@/components/chap139439'
 import CHAP139426 from '@/components/chap139426'
 import CHAP139409 from '@/components/chap139409'
 import CHAP139402 from '@/components/chap139402'
 import CHAP139407 from '@/components/chap139407'
 import CHAP139412 from '@/components/chap139412'
 import CHAP139403 from '@/components/chap139403'
 import CHAP139419 from '@/components/chap139419'
 import CHAP139411 from '@/components/chap139411'
 import CHAP139414 from '@/components/chap139414'
 import CHAP139404 from '@/components/chap139404'
 import LOVE_2 from '@/components/love_2'
 import CHAP153474 from '@/components/chap153474'
 import CHAP139446 from '@/components/chap139446'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/chap139438",
 			"name" : "chap139438",
 			"component" : CHAP139438
 		},
 		{
 			"path" : "/chap139422",
 			"name" : "chap139422",
 			"component" : CHAP139422
 		},
 		{
 			"path" : "/chap139417",
 			"name" : "chap139417",
 			"component" : CHAP139417
 		},
 		{
 			"path" : "/chap139416",
 			"name" : "chap139416",
 			"component" : CHAP139416
 		},
 		{
 			"path" : "/chap139424",
 			"name" : "chap139424",
 			"component" : CHAP139424
 		},
 		{
 			"path" : "/chap139423",
 			"name" : "chap139423",
 			"component" : CHAP139423
 		},
 		{
 			"path" : "/chap139440",
 			"name" : "chap139440",
 			"component" : CHAP139440
 		},
 		{
 			"path" : "/chap139441",
 			"name" : "chap139441",
 			"component" : CHAP139441
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js